import { useEffect, useState } from 'react';

export default function AccessibilityWidget() {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(() => {
    try { return JSON.parse(localStorage.getItem('fm_a11y') || '{}'); }
    catch { return {}; }
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('a11y-large', !!settings.large);
    root.classList.toggle('a11y-xlarge', !!settings.xlarge);
    root.classList.toggle('a11y-contrast', !!settings.contrast);
    root.classList.toggle('a11y-grayscale', !!settings.grayscale);
    root.classList.toggle('a11y-underline', !!settings.underline);
    root.classList.toggle('a11y-no-motion', !!settings.noMotion);
    try { localStorage.setItem('fm_a11y', JSON.stringify(settings)); } catch {}
  }, [settings]);

  const toggle = k => setSettings(s => ({ ...s, [k]: !s[k] }));
  const reset = () => setSettings({});

  return (
    <>
      <button className="fab-a11y" aria-label="הגדרות נגישות" onClick={() => setOpen(o => !o)}>
        <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor" aria-hidden="true">
          <circle cx="12" cy="3.5" r="2"/>
          <path d="M14 7H10c-1.1 0-2 .9-2 2v5c0 .6.4 1 1 1h1v5h4v-5h1c.6 0 1-.4 1-1V9c0-1.1-.9-2-2-2z"/>
          <path d="M10 7.5v3.5H8.5L7 7.5H10z" opacity=".4"/>
          <circle cx="9" cy="20.5" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.8"/>
          <circle cx="15" cy="19.5" r="1.5" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M11 14.5l-2 1.5" strokeWidth="1.2" stroke="currentColor" fill="none"/>
        </svg>
      </button>
      {open && (
        <div className="a11y-panel" role="dialog" aria-label="הגדרות נגישות">
          <div className="a11y-head">
            <h3>הגדרות נגישות</h3>
            <button className="a11y-x" aria-label="סגירה" onClick={() => setOpen(false)}>×</button>
          </div>
          <div className="a11y-grid">
            <button className={'a11y-opt' + (settings.large ? ' on' : '')} onClick={() => toggle('large')}>טקסט גדול</button>
            <button className={'a11y-opt' + (settings.xlarge ? ' on' : '')} onClick={() => toggle('xlarge')}>טקסט ענק</button>
            <button className={'a11y-opt' + (settings.contrast ? ' on' : '')} onClick={() => toggle('contrast')}>ניגודיות גבוהה</button>
            <button className={'a11y-opt' + (settings.grayscale ? ' on' : '')} onClick={() => toggle('grayscale')}>גווני אפור</button>
            <button className={'a11y-opt' + (settings.underline ? ' on' : '')} onClick={() => toggle('underline')}>הדגשת קישורים</button>
            <button className={'a11y-opt' + (settings.noMotion ? ' on' : '')} onClick={() => toggle('noMotion')}>עצירת תנועה</button>
          </div>
          <button className="a11y-reset" onClick={reset}>איפוס הגדרות</button>
          <p className="a11y-foot">
            האתר עומד בתקן ישראלי 5568 ברמת AA. לפניות בנושא נגישות:{' '}
            <a href="mailto:yoav@focusmode.info">yoav@focusmode.info</a>
          </p>
        </div>
      )}
    </>
  );
}
